import React, { useState } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Button,
    Box,
    Text,
    useDisclosure,
    TableContainer,
    VStack,
    Flex,
} from "@chakra-ui/react";
import { FaTrophy } from "react-icons/fa";
import ConfirmationModal from "./ConfirmationModal";

const OutcomeModal = ({ isOpen, onClose, marketName, outcomes }) => {
    const {
        isOpen: isConfirmOpen,
        onOpen: onConfirmOpen,
        onClose: onConfirmClose
    } = useDisclosure();
    const [selectedOutcome, setSelectedOutcome] = useState("");

    const handleSelectClick = (name) => {
        setSelectedOutcome(name);
        onConfirmOpen();
    };

    const handleFinalConfirm = () => {
        console.log("Finalized outcome selection:", selectedOutcome);
        onConfirmClose();
        onClose();
    };

    return (
        <>
            <Modal isOpen={isOpen} onClose={onClose} size={{ base: "full", lg: "4xl" }} isCentered>
                <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(2px)" />
                <ModalContent borderRadius={{ base: "none", lg: "xl" }} overflow="hidden">
                    <ModalHeader fontSize="xl" fontWeight="600" py={4}>
                        Outcomes for - {marketName}
                    </ModalHeader>
                    <ModalCloseButton mt={2} />
                    <ModalBody p={{ base: 4, md: 6 }}>
                        <Box borderRadius="md" overflow="hidden" borderWidth="1px" borderColor="gray.100" display={{ base: "none", md: "block" }}>
                            <TableContainer>
                                <Table variant="simple">
                                    <Thead bg="#4f46e5">
                                        <Tr>
                                            <Th color="white" textTransform="none" fontSize="sm" fontWeight="600" py={4}>
                                                Name
                                            </Th>
                                            <Th color="white" textTransform="none" fontSize="sm" fontWeight="600" py={4}>
                                                Rate
                                            </Th>
                                            <Th color="white" textTransform="none" fontSize="sm" fontWeight="600" py={4}>
                                                Bet Count
                                            </Th>
                                            <Th color="white" textTransform="none" fontSize="sm" fontWeight="600" py={4} textAlign="right">
                                                Action
                                            </Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        {outcomes && outcomes.map((item, index) => (
                                            <Tr key={index} _hover={{ bg: "gray.50" }}>
                                                <Td py={4}>
                                                    <Text fontWeight="500" color="gray.700">
                                                        {item.name}
                                                    </Text>
                                                </Td>
                                                <Td py={4}>{item.rate}</Td>
                                                <Td py={4}>{item.betCount}</Td>
                                                <Td py={4} textAlign="right">
                                                    <Button
                                                        leftIcon={<FaTrophy size="12px" />}
                                                        variant="outline"
                                                        colorScheme="blue"
                                                        size="sm"
                                                        borderRadius="md"
                                                        fontSize="xs"
                                                        px={4}
                                                        onClick={() => handleSelectClick(item.name)}
                                                    >
                                                        Select
                                                    </Button>
                                                </Td>
                                            </Tr>
                                        ))}
                                    </Tbody>
                                </Table>
                            </TableContainer>
                        </Box>

                        {/* Mobile View */}
                        <VStack display={{ base: "flex", md: "none" }} spacing={3} align="stretch">
                            {outcomes && outcomes.map((item, index) => (
                                <Box key={index} p={4} borderWidth="1px" borderRadius="md" borderColor="gray.200" bg="gray.50">
                                    <Flex justify="space-between" align="center" mb={2}>
                                        <Text fontWeight="600" color="gray.700" fontSize="md">{item.name}</Text>
                                        <Text fontWeight="bold" color="blue.600">{item.rate}</Text>
                                    </Flex>
                                    <Flex justify="space-between" align="center" mb={3}>
                                        <Text fontSize="sm" color="gray.500">Bet Count: {item.betCount}</Text>
                                    </Flex>
                                    <Button
                                        leftIcon={<FaTrophy size="12px" />}
                                        colorScheme="blue"
                                        size="sm"
                                        width="full"
                                        onClick={() => handleSelectClick(item.name)}
                                    >
                                        Select
                                    </Button>
                                </Box>
                            ))}
                        </VStack>
                    </ModalBody>
                </ModalContent>
            </Modal>

            <ConfirmationModal
                isOpen={isConfirmOpen}
                onClose={onConfirmClose}
                onConfirm={handleFinalConfirm}
                message={`Are you sure to select ${selectedOutcome}?`}
            />
        </>
    );
};

export default OutcomeModal;
